import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/ux-fabric"
import {Grid} from "@mui/material"
import {ContentContainer, ContentContainerProps} from "../../../components"

export type ClubContentContainerProps = ContentContainerProps & {
    xxlBreakpointEnabled: boolean
}

export const ContentContainerStyled = styled(ContentContainer)<ClubContentContainerProps>`
    @media (min-width: ${breakpoints.values.md}px) {
        border-right: 0.0625rem solid ${({theme}) => theme.uxfabric.components.menu.searchMenu.default.borderColor};
        padding: ${({showSelectionHighlight}) =>
            showSelectionHighlight ? "1rem 0 1rem 0rem" : "0.5rem 0 1rem 1.5rem"};
        max-width: 25%;
        margin-left: 0rem;
        min-width: 12.75rem;
    }

    @media (min-width: ${breakpoints.values.lg}px) {
        min-width: 16rem;
    }

    @media (min-width: ${breakpoints.values.xl}px) {
        min-width: 20rem;
    }

    ${({xxlBreakpointEnabled}) =>
        xxlBreakpointEnabled &&
        `@media (min-width: ${breakpoints.values.xxl}px) {
            max-width: 21rem;
        }`}
`

export const SecondaryContentContainer = styled("div")`
    max-width: 100%;
    width: 100%;
    padding: 1rem;
    padding-right: 0;
    height: 25rem;
    background: ${({theme}) => theme.uxfabric.components.menu.searchMenu.enriched.backgroundColor};

    @media (min-width: ${breakpoints.values.md}px) {
        padding: 1rem;
    }
`

export const AutocompleteContent = styled("div")`
    width: 100%;
    ul {
        @media (min-width: ${breakpoints.values.sm}px) and (max-width: ${breakpoints.values.md - 1}px) {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;

            li {
                flex-basis: calc(100% / 2);
                padding-right: 1rem;
            }
        }
    }
`

export type GridWrapperProps = {
    isRecentSearches: boolean
    showSelectionHighlight: boolean
}

export const GridWrapper = styled(Grid, {
    shouldForwardProp: p => p !== "isRecentSearches" && p !== "showSelectionHighlight",
})<GridWrapperProps>`
    @media (min-width: ${breakpoints.values.md}px) {
        display: flex;
        padding-top: ${({isRecentSearches}) => (isRecentSearches ? "1rem" : "0")};
        padding-left: 0;
        padding-right: 0;
        padding-bottom: 0;
        border-bottom: none;
        ${({showSelectionHighlight, theme}) =>
            showSelectionHighlight
                ? `
                ul li a{
                    padding-left: 0.75rem;
                }
                ul li {
                    &:hover {
                        border-left: 0.25rem solid ${theme.uxfabric.primary.main};
                        border-top: 0.063rem solid ${theme.uxfabric.components.menu.searchMenu.default.borderColor};
                        border-bottom: 0.063rem solid ${theme.uxfabric.components.menu.searchMenu.default.borderColor};
                        border-right: 0.063rem solid ${theme.uxfabric.components.menu.searchMenu.enriched.backgroundColor};
                        a {
                            padding: 0.4375rem 0 0.4375rem 0.75rem;
                            text-decoration: none;
                        }
                    }
                    
                }`
                : `ul li a {
                    transition: transform 0.1s ease, padding 0.15s ease;
                    &:hover {
                        padding-left: 0.5rem;
                    }
                }`}
    }

    padding: 0.75rem 1rem 0.25rem 1rem;
    border-bottom: ${({isRecentSearches, theme}) =>
        isRecentSearches ? "none" : `0.0625rem solid ${theme.uxfabric.components.menu.searchMenu.default.borderColor}`};

    @media (max-width: ${breakpoints.values.md - 1}px) {
        padding-top: 0.25rem;
    }
`

export const HeaderContainer = styled("div")`
    align-items: center;
    border-top: 0.0625rem solid ${({theme}) => theme.uxfabric.components.card.cardHeader.default.borderColor};
    border-bottom: 1px solid ${({theme}) => theme.uxfabric.components.card.cardHeader.default.borderColor};
    color: ${({theme}) => theme.uxfabric.text.primary};
    background: ${({theme}) => theme.uxfabric.components.card.cardHeader.default.backgroundColor};

    @media (max-width: ${breakpoints.values.md - 1}px) {
        padding: 0.75rem 1rem;
    }

    @media (min-width: ${breakpoints.values.md}px) {
        background: transparent;
        border: none;
    }
`
